<template>
  <div class="ui main container">
    <h2>Finalizar pedido</h2>
    <Stepper :steps="steps"></Stepper>
  </div>
</template>

<script>
import Stepper from '../components/Stepper';
import Divider from '../components/checkout/Divider';
import CustomerForm from '../components/customer/CustomerForm';
import ShippingAddress from '../components/customer/ShippingAddress';
import OrderConfirmationForm from '../components/cart/OrderConfirmationForm';

export default {
  name: 'Checkout',
  data: function() {
    return {
      steps: [
        {
          icon: 'user icon',
          name: 'customer',
          title: 'Información Personal',
          subtitle: '',
          component: Divider
        },
        {
          icon: 'truck icon',
          name: 'shipping',
          title: 'Dirección de envio',
          subtitle: '',
          component: ShippingAddress
        },
        {
          icon: 'info circle icon',
          name: 'confirmation',
          title: 'Confirmar Orden',
          subtitle: '',
          component: OrderConfirmationForm
        }
      ]
    };
  },
  components: {
    Stepper
  }
};
</script>

<style></style>
